<template>
  <div class="app-counter bg-cas-secondary" :class="{ 'bg-cas-light-200 text-white': !value }">
    {{ value }}
  </div>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
  },
}
</script>

<style lang="scss">
.app-counter {
  min-width: 20px;
  height: 20px;
  padding: 0 4px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  border-radius: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #121212;
  margin-left: 8px;
  font-style: normal;
}
</style>
